export class Settings {
    public constructor(settings: any) {
        Object.assign(this, settings);
    }
}
export interface Settings {
    base: string;
    url(url: string): string;
    name: string;
    slag:string
    author: string;
    description: string;
    minDate: string;
    mainMenu: Array<{ icon: [string, string]; title: string; to: string; exact: boolean }>;
    errorPages: {
        default: { icon: [string, string]; title: string; message: string; statusCode: number };
        [code: string]: { icon: [string, string]; title: string; message: string; statusCode: number };
    };
    card: string;
    headerLogo: string;
    headerLogoLine: string;
    footerLogo: string;
    sandozFooterLogo: string;
    warningIcon: string;
    cardTypeQuestionId: string;
    cardTypeAnswerId: string;
    programId: string;
    surveyId: string;
    clsProgramId: string;
    eligibilityFederalQuestion: string;
    eligibilityFederalYes: string;
    eligibilityFederalNo: string;
    eligibilityPrescribedQuestion: string;
    eligibilityPrescribedYes: string;
    eligibilityPrescribedNo: string;
    eligibilityCommercialInsuranceQuestion: string;
    eligibilityCommercialInsuranceYes: string;
    eligibilityCommercialInsuranceNo: string;
    eligibilityTermConditionQuestion: string;
    eligibilityTermConditionYes: string;
    eligibilityTermConditionNo: string;
    PharmacyEligibilityFederalQuestion: string;
    PharmacyEligibilityFederalYes: string;
    PharmacyEligibilityFederalNo: string;
    PharmacyEligibilityPrescribedQuestion: string;
    PharmacyEligibilityPrescribedYes: string;
    PharmacyEligibilityPrescribedNo: string;
    PharmacyEligibilityCommercialInsuranceQuestion: string;
    PharmacyEligibilityCommercialInsuranceYes: string;
    PharmacyEligibilityCommercialInsuranceNo: string;
    PharmacyEligibilityTermConditionQuestion: string;
    PharmacyEligibilityTermConditionYes: string;
    PharmacyEligibilityTermConditionNo: string;
    consentCheckboxQuestion: string;
    consentCheckboxAnswer: string;
    tncCheckboxQuestion: string;
    tncCheckboxAnswer: string;
    fcraCheckboxQuestion: string;
    fcraCheckboxAnswer: string;
    tcpaConsentCheckboxQuestion: string;
    tcpaConsentCheckboxAnswer: string;
    triangleUp: string;
    triangleDown: string;
    lockEnabled: string;
    lockPassword: string;
    phone: string;
    IsPatientAgeBetween6And17Question:string;
    IsPatientAgeBetween6And17AnswerYes:string;
    IsPatientAgeBetween6And17AnswerNo:string;
    pathQuestion:string;
    pathPatientAnswer:string;
    pathHCPAnswer:string;
    pathPharmacyAnswer:string;
    patientAuthFirstName:string;
    patientAuthFirstNameAnswer:string;
    patientAuthLastName:string;
    patientAuthLastNameAnswer:string;
    prescriberSignature:string;
    prescriberSignatureAnswer:string;
    pharmacistSignature:string;
    pharmacistSignatureAnswer:string;
    ncpdp:string;
    ncpdpAnswer:string;
    privacyCheckboxQuestion: string;
    privacyCheckboxAnswer: string;
    pharmacyPatientConsentToAuthorizationQuestion: string;
    pharmacyPatientConsentToAuthorizationAnswer: string;
    pharmacyPatientAgreeTermsAndConditionsQuestion: string;
    pharmacyPatientAgreeTermsAndConditionsAnswer: string;
    pharmacyPatientAgreesPrivacyPolicyQuestion: string;
    pharmacyPatientAgreesPrivacyPolicyAnswer: string;
    relationshipToPatient: string;
    relationshipToPatientAnswer: string;
    todaysDate: string;
    todaysDateAnswer: string;
    patientInformationPageRelationshipToPatientQuestion: string;
    patientInformationPageRelationshipToPatientAnswer: string;
    caregiverEmailAddressQuestion: string;
    caregiverEmailAddressAnswer: string;
    caregiverMobilePhoneQuestion: string;
    caregiverMobilePhoneAnswer: string;
    caregiverHomePhoneQuestion: string;
    caregiverHomePhoneAnswer: string;
    shouldShowSplashPage: string;

    // Pharmacy
    phEligibilityFederalQuestion: string;
    phEligibilityFederalYes: string;
    phEligibilityFederalNo: string;

    phEligibilityPrescribedQuestion: string;
    phEligibilityPrescribedYes: string;
    phEligibilityPrescribedNo: string;

    phEligibilityCommercialInsuranceQuestion: string;
    phEligibilityCommercialInsuranceYes: string;
    phEligibilityCommercialInsuranceNo: string;

    phEligibilityTermConditionQuestion: string;
    phEligibilityTermConditionYes: string;
    phEligibilityTermConditionNo: string;


}
